import { useTranslateForm } from 'hooks/use-translate-payoff';
import { DefaultBlockDefinition } from 'models/metadata/block.definition';
import { PropsWithChildren } from 'react';
import { ErrorBadge } from 'routes/essential-workspace/components/form/blocks/error-badge';
import { EssentialBlockNode } from 'routes/essential-workspace/state/model';

type DefaultBlockProps = PropsWithChildren<EssentialBlockNode & DefaultBlockDefinition>;

export function DefaultBlockItem({ id, children, errors }: DefaultBlockProps) {
  const { translateLabel } = useTranslateForm();
  const label = translateLabel(id);

  return (
    <section className="grid gap-2" data-block-id={id} aria-label={label}>
      <header className="flex-x pt-2 g-col-12 gap-2" style={{ height: 32 }}>
        <h2 className="text-start fs-14 text-secondary fw-normal m-0">{label}</h2>
        <ErrorBadge errors={errors} />
      </header>
      {children}
    </section>
  );
}
